export const mockConversations = [
    {
        id: "lead_001",
        name: "João Silva",
        phone: "+55 79 93213-2123",
        owner: "SDR 1",

        createdAt: "2026-01-27T09:15:00",
        lastMessageAt: "2026-01-27T09:20:00",

        responded: false,
        stage: "Novo",
        enrolled: false,

        lastUserMessage: "Olá, gostaria de mais informações.",

        messages: [
            {
                from: "lead",
                text: "Olá, gostaria de mais informações.",
                time: "09:20",
            },
        ],

        appointment: null,
    },

    {
        id: "lead_002",
        name: "Maria Souza",
        phone: "+55 79 92381-1324",
        owner: "SDR 2",

        createdAt: "2026-01-27T08:40:00",
        lastMessageAt: "2026-01-27T08:55:00",

        responded: true,
        stage: "Agendamento",
        enrolled: false,

        lastUserMessage: "Quando posso agendar uma visita?",

        messages: [
            {
                from: "lead",
                text: "Quando posso agendar uma visita?",
                time: "08:55",
            },
            {
                from: "me",
                text: "Claro! Qual horário fica melhor para você?",
                time: "08:56",
            },
        ],

        appointment: {
            date: "2026-01-27",
            time: "10:30",
            type: "Visita / Diagnóstico",
            status: "Confirmado", // Pendente | Confirmado | Atrasado | Concluído
            notes: "Preferência por horário da manhã",
        },
    },

    {
        id: "lead_003",
        name: "Pedro Lima",
        phone: "+55 79 99376-1235",
        owner: "SDR 1",

        createdAt: "2026-01-22T14:10:00",
        lastMessageAt: "2026-01-22T15:00:00",

        responded: true,
        stage: "Matrícula",
        enrolled: true,

        lastUserMessage: "Já fiz minha matrícula!",

        messages: [
            {
                from: "lead",
                text: "Já fiz minha matrícula!",
                time: "15:00",
            },
            {
                from: "me",
                text: "Perfeito! Seja bem-vindo(a) 🎉",
                time: "15:01",
            },
        ],

        appointment: {
            date: "2026-01-22",
            time: "14:00",
            type: "Matrícula",
            status: "Concluído",
            notes: "Matrícula finalizada com sucesso",
        },
    },

    {
        id: "lead_004",
        name: "Ana Costa",
        phone: "+55 79 99207-8765",
        owner: "SDR 3",

        createdAt: "2026-01-10T11:00:00",
        lastMessageAt: "2026-01-10T11:40:00",

        responded: false,
        stage: "Novo",
        enrolled: false,

        lastUserMessage: "Ainda estou interessada no curso.",

        messages: [
            {
                from: "lead",
                text: "Ainda estou interessada no curso.",
                time: "11:40",
            },
        ],

        appointment: null,
    },

    {
        id: "lead_005",
        name: "Lucas Rocha",
        phone: "+55 79 96382-2579",
        owner: "SDR 2",

        createdAt: "2026-01-26T17:30:00",
        lastMessageAt: "2026-01-26T18:10:00",

        responded: true,
        stage: "Agendamento",
        enrolled: false,

        lastUserMessage: "Qual é o próximo passo para agendar?",

        messages: [
            {
                from: "lead",
                text: "Qual é o próximo passo para agendar?",
                time: "18:10",
            },
            {
                from: "me",
                text: "Vou te explicar agora 😊",
                time: "18:11",
            },
        ],

        appointment: {
            date: "2026-01-28",
            time: "16:30",
            type: "Aula Experimental",
            status: "Pendente",
            notes: "Interessado em inglês adulto",
        },
    },
];